<div class="map" leaflet [leafletOptions]="options" [leafletLayersControl]="layersControl"
    (leafletMapReady)="onMapReady($event)">

    <div [leafletLayer]="drawnItems"></div>
</div>

